/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractCurrentlyInDiscussionLayout from './AbstractCurrentlyInDiscussionLayout';

export default class ReadingChallenge extends AbstractCurrentlyInDiscussionLayout {
	get key() {
		return 'reading_challenge BannerLayout--currently_in_discussion';
	}
}
